// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".control-bar-nav[data-v-52e16d1e]{display:inline-flex;align-items:center;flex-shrink:0;gap:4px}", ""]);
// Exports
module.exports = exports;
